import { Component, OnInit, Input } from '@angular/core';
import { Question } from "../../shared/models/question";
import { ChecklistQuestion } from "../../shared/models/checklist-question";
import { QuestionComponent } from "../question/question.component";
import { QuestionSetLabel } from "../../shared/models/question-set-label";
import { QuestionType } from "../../shared/models/question-type";

@Component({
  selector: 'dac-question-checklist',
  templateUrl: './question-checklist.component.html',
  styleUrls: ['./question-checklist.component.css']
})
export class QuestionChecklistComponent extends QuestionComponent implements OnInit {

  @Input("question") question:Question;
  private _checklistQuestion:ChecklistQuestion;


  constructor() { 
    super();
  }

  ngOnInit() {
    if (this.question && this.question.type == QuestionType.Checklist) {
      this._checklistQuestion = this.question as ChecklistQuestion;
    }
  }

  updateAnswers(label:QuestionSetLabel, event:Event) {
    event.stopPropagation();
    event.preventDefault();
    if ((event.currentTarget as HTMLInputElement).checked) {
      this._checklistQuestion.removeAnswer(label);
    }
    else {
      this._checklistQuestion.addAnswer(label);
    }
    this.notifyAnswered();
    // this.question.answer = answer;
  }

  public isAnswer(label:QuestionSetLabel) {
    return this._checklistQuestion.hasAnswer(label);
  }

  public get Question() {
    return this._checklistQuestion;
  }

}



// WEBPACK FOOTER //
// ./src/app/assessments/question-checklist/question-checklist.component.ts